import { render } from "./ScanCheckDetail.vue?vue&type=template&id=3d4638fd"
import script from "./ScanCheckDetail.vue?vue&type=script&lang=js"
export * from "./ScanCheckDetail.vue?vue&type=script&lang=js"

import "./ScanCheckDetail.vue?vue&type=style&index=0&id=3d4638fd&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__